import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Page, { PageProps } from '../../../common/components/page';
import forDevice from '../../../common/hoc/for-device';
import styles from './post-page-layout.scss';

const PostPageLayoutMobile: React.FC<PageProps> = ({
  children,
  ...otherProps
}) => <Page {...otherProps}>{children}</Page>;

PostPageLayoutMobile.propTypes = {
  children: PropTypes.node,
};

const PostPageLayoutDesktop: React.FC<PageProps> = ({
  children,
  className,
  ...otherProps
}) => (
  <Page className={classNames(styles.container, className)} {...otherProps}>
    {children}
  </Page>
);

PostPageLayoutDesktop.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default forDevice(PostPageLayoutMobile, PostPageLayoutDesktop);
